import { render, staticRenderFns } from "./BannerFundraisingGoals.vue?vue&type=template&id=55db7296&scoped=true&"
import script from "./BannerFundraisingGoals.vue?vue&type=script&lang=ts&"
export * from "./BannerFundraisingGoals.vue?vue&type=script&lang=ts&"
import style0 from "./BannerFundraisingGoals.vue?vue&type=style&index=0&id=55db7296&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55db7296",
  null
  
)

export default component.exports